import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-nine',
  templateUrl: './home-twenty-nine.component.html',
  styleUrls: ['./home-twenty-nine.component.scss']
})
export class HomeTwentyNineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
